import React from 'react';
import l from 'components/util/l';
import 'styles/css/agent/Quoting.css';

const PortalDevelopingView = () => {
	return (
		<div className="container-fluid agent-quoting-container">
			<div className="row justify-content-center align-items-center min-vh-70">
				<div>
					<div className="card shadow-lg border-0 bg-dark-opaque animate__animated animate__fadeIn"
						style={{ maxWidth: '36rem' }}>
						<div className="card-body p-7 text-center d-flex flex-column align-items-center justify-content-center">
							<div className="mb-4 animate__animated animate__zoomIn">
								<i className="fas fa-cogs text-primary" style={{ fontSize: '5rem' }}></i>
							</div>

							<h1 className="display-4 font-weight-bold text-white mb-4 animate__animated animate__fadeInDown">
								{l('Solución en desarrollo%PA509')}
							</h1>

							<div className="lead text-light animate__animated animate__fadeInUp">
								<p className="mb-0">
									{l('En este momento estamos creando tu solución%PA510')}...
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PortalDevelopingView;
